import Vue from "vue";
import App from "@/outside/App";
import router from "@/outside/router";
import i18n from "@/common/plugins/i18n";

Vue.config.productionTip = false;
Vue.use(i18n, {
    debug: process.env.VUE_APP_ENVIRONMENT !== "production"
});

new Vue({
    render: h => h(App),
    router: router
}).$mount("#app");
